<div class="search flex justify-content-between align-items-center">
    <input #inputSearch type="text" [formControl]="formControl" [placeholder]="placeholder" />
    <p-button 
    *ngIf="formControl.value && formControl.value.length > 0"
    icon="pi pi-times"
    [rounded]="true" 
    severity="secondary" 
    (click)="clear()"
    [text]="true">
    </p-button>
    <button class="search">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0007 14.0002L11.01 11.0042M12.6673 7.00016C12.6673 8.50306 12.0703 9.9444 11.0076 11.0071C9.94488 12.0698 8.50354 12.6668 7.00065 12.6668C5.49776 12.6668 4.05642 12.0698 2.99371 11.0071C1.93101 9.9444 1.33398 8.50306 1.33398 7.00016C1.33398 5.49727 1.93101 4.05593 2.99371 2.99322C4.05642 1.93052 5.49776 1.3335 7.00065 1.3335C8.50354 1.3335 9.94488 1.93052 11.0076 2.99322C12.0703 4.05593 12.6673 5.49727 12.6673 7.00016Z"
          stroke="#086975"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
</div>
